import React, { useState } from "react";
import { db } from "../config/firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faYoutube, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2"; // Import SweetAlert2

function SocialMediaButton(params) {
  return (
    <div className="socialMediaButton">
      <a href="#" className="sButton">
        <FontAwesomeIcon icon={params.icon} className="icon" />
      </a>
      <style>
        {`
          .socialMediaButton {
            text-align: center;
          }
          .sButton {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: white;
            margin-right: 8px;
            margin-top: 10px;
            box-shadow: 0px 7px 5px rgba(0, 0, 0, 0.5);
            transition: transform 0.5s, background-color 0.5s;
            text-decoration: none;
          }
          .sButton:hover {
            transform: translateY(-7px);
            background-color: ${params.backgroundColor};
          }
          .sButton .icon {
            color: #4c2a7b;
            box-shadow: 5px 10px 20px rgba(150, 150, 150, 0.3);
            font-size: 20px;
            transition: color 0.5s;
          }
          .sButton:hover .icon {
            color: #ffffff;
          }
        `}
      </style>
    </div>
  );
}

function SocialMediaButtons() {
  return (
    <div className="SocialMediaMenu">
      <div className="S-container">
        <SocialMediaButton icon={faInstagram} backgroundColor="#6836c5" />
        <SocialMediaButton icon={faYoutube} backgroundColor="#6836c5" />
        <SocialMediaButton icon={faTiktok} backgroundColor="#6836c5" />
      </div>
      <style>
        {`
          .SocialMediaMenu {
            display: flex;
            justify-content: left;
            align-items: left;
          }
          .S-container {
            display: flex;
          }
        `}
      </style>
    </div>
  );
}

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      // Check if the email is valid
      Swal.fire("Error", "Please enter a valid email address.", "error");
      return;
    }

    try {
      // Check if email already exists in Firestore
      const q = query(collection(db, "newsletter"), where("email", "==", email));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        // Email is already subscribed
        Swal.fire("Already Subscribed", "This email is already subscribed.", "info");
        return;
      }

      // Save the email to Firestore
      await addDoc(collection(db, "newsletter"), {
        email: email,
        timestamp: new Date(),
      });

      // Show success message
      Swal.fire("Subscribed!", "Thank you for subscribing to our newsletter.", "success");

      // Clear the email input after successful subscription
      setEmail("");
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "There was an error subscribing. Please try again later.", "error");
    }
  };

  return (
    <div className="footerdiv">
      <footer className="f-footer">
        <div className="f-container">
          <div className="f-row">
            <div className="f-footer-col" id="f-big">
              <h4>Punjabi Boli</h4>
              <div>
                <FontAwesomeIcon className="mail" icon={faEnvelope} />
                <span className="f-h5"> team@PunjabiBoli.ca</span>
              </div>
              <h5 className="f-h5">Follow Us On</h5>
              <div className="f-social-links">
                <SocialMediaButtons />
              </div>
            </div>
            <div className="f-footer-col">
              <h4 className="bottom">Resources</h4>
              <ul>
                <li><a href="/courses">Courses</a></li>
                <li><a href="/blog">Blogs</a></li>
              </ul>
            </div>
            <div className="f-footer-col">
              <h4 className="bottom">Links</h4>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/faq">FAQ</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
            <div className="f-footer-col" id="f-big">
              <h4 className="bottom">Newsletter</h4>
              <h5 className="f-h5">Join to receive updates about future events and new courses.</h5>
              <form className="f-newsletter-form" onSubmit={handleSubscribe}>
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  value={email} 
                  onChange={handleEmailChange} 
                  required 
                />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
        <style jsx>{`
          body {
            line-height: 1.5;
            font-family: "Poppins", sans-serif;
          }
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          .footerdiv {
            margin-bottom: 0px;
            padding: 0px;
            margin-top: -80px;
          }
          .mail {
            color: white;
          }
          .f-container {
            max-width: 1170px;
            margin: 0 auto;
            width: 80%;
            text-align: left;
          }
          .f-row {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
          }
          ul {
            list-style: none;
          }
          .f-footer {
            background-color: #000000;
            padding: 65px 0;
            margin-bottom: 0px;
            justify-content: center;
            align-content: center;
            border-top: 3px solid #6836c5;
          }
          .f-footer-col {
            width: 20%;
            padding: 0 15px;
          }
          #f-big {
            width: 30%;
          }

          .f-footer-col h4 {
            font-size: 25px;
            color: white;
            text-transform: capitalize;
            margin-bottom: 35px;
            font-weight: 500;
            position: relative;
          }
          .f-footer-col h4::before {
            content: "";
            position: absolute;
            left: 0;
            bottom: -10px;
            background-color: #6836c5;
            height: 2px;
            width: 50px;
          }
          .f-footer-col ul li:not(:last-child) {
            margin-bottom: 10px;
          }
          .f-footer-col ul li a {
            font-size: 18px;
            text-transform: capitalize;
            text-decoration: none;
            font-weight: 300;
            color: white;
            display: block;
            transition: all 0.3s ease;
          }
          .f-footer-col ul li a:hover {
            color: #a36ce6;
            padding-left: 8px;
          }

          @media (max-width: 900px) {
            .f-footer-col {
              width: 50%;
            }
            #f-big {
              width: 100%;
            }
            .bottom {
              margin-top: 25px;
            }
          }
          @media (max-width: 574px) {
            .f-footer-col {
              width: 90%;
            }
            #f-big {
              width: 90%;
            }
          }
          .f-h5 {
            color: white;
            font-size: 17px;
            margin-top: 10px;
            margin-bottom: 5px;
          }
          .f-newsletter-form {
            display: flex;
            margin-top: 20px;
          }
          .f-newsletter-form input[type="email"] {
            padding: 10px;
            width: 70%;
            border: none;
            border-radius: 4px;
          }
          .f-newsletter-form button[type="submit"] {
            background-color: #6836c5;
            color: white;
            border: none;
            border-radius: 4px;
            padding: 10px 20px;
            cursor: pointer;
            transition: background-color 0.3s;
          }
          .f-newsletter-form button[type="submit"]:hover {
            background-color: #a36ce6;
          }
        `}</style>
      </footer>
    </div>
  );
}
